import React from "react";
import nftVolumesStyles from "./scss/nft-details.module.scss";

const NftVolumeBox = ({ title, image, graph, value, time }) => {
  return (
    <div className="col-xl-3 col-md-6 mb-xl-0 mb-3">
      <div className={`${nftVolumesStyles.volumeBox} h-100`}>
        <ul className="list-unstyled">
          <li>
            <label className={nftVolumesStyles.labelTag}>
              {title}
              <img className="img-fluid float-right" src={image} alt="" />
            </label>
            <div className={nftVolumesStyles.labelRate}>{value}</div>
          </li>
          <li>
            <div className={nftVolumesStyles.labelRate}>
              <img className="img-fluid" src={graph} alt="" />
            </div>
            <label className="secondary-text text-center d-block">{time}</label>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default NftVolumeBox;
